module.exports = __webpack_public_path__ + "img/card_sv2.b44917f.png";